export const isVimOsAppMode = true;
